/**
 * Extracts file extension from signed URL by parsing the path segment
 * @param signedUrl The signed URL containing the filename with extension
 * @returns File extension including the dot (e.g., '.png', '.pdf', '.docx')
 */
export function getFileExtensionFromSignedUrl(signedUrl: string): string {
	try {
		// Find the query parameters start
		const questionMarkIndex = signedUrl.indexOf('?');
		const urlPath =
			questionMarkIndex !== -1
				? signedUrl.substring(0, questionMarkIndex)
				: signedUrl;

		// Find the last path segment (filename)
		const lastSlashIndex = urlPath.lastIndexOf('/');
		if (lastSlashIndex === -1) {
			return '';
		}

		const filename = urlPath.substring(lastSlashIndex + 1);

		// Decode URL encoding
		const decodedFilename = decodeURIComponent(filename);

		// Find extension in filename
		const lastDotIndex = decodedFilename.lastIndexOf('.');

		if (lastDotIndex !== -1 && lastDotIndex < decodedFilename.length - 1) {
			const extension = decodedFilename.substring(lastDotIndex);
			// Validate it's a reasonable extension (3-5 characters, starts with dot)
			if (
				extension.length >= 4 &&
				extension.length <= 6 &&
				extension.match(/^\.[a-zA-Z0-9]+$/)
			) {
				return extension.toLowerCase();
			}
		}

		return '';
	} catch (error) {
		console.error('Error extracting extension from signed URL:', error);
		return '';
	}
}

/**
 * Validates if a string looks like a valid file extension
 */
export function isValidFileExtension(extension: string): boolean {
	const validExtensions = [
		'.pdf',
		'.doc',
		'.docx',
		'.txt',
		'.jpg',
		'.jpeg',
		'.png',
		'.gif',
		'.bmp',
		'.webp',
		'.xls',
		'.xlsx',
		'.csv',
		'.zip',
		'.rar',
		'.7z',
	];

	return validExtensions.includes(extension.toLowerCase());
}

export function getFileNameFromSignedUrl(
	signedUrl: string,
	withExtension: boolean = false,
): string {
	const extension = withExtension
		? getFileExtensionFromSignedUrl(signedUrl)
		: '';
	return (
		signedUrl.split('?')[0].split('/').pop() + (withExtension ? extension : '')
	);
}
